import { makePieActionObjs } from 'shared/imports/pieActionGenerators'
import { prependAppName } from 'shared/imports/sharedHelperFunctions'

const appName = '@@lists/'

const lockListObj = makePieActionObjs('patch', 'lock_list')
const unlockListObj = makePieActionObjs('patch', 'unlock_list')
const unAutoListObj = makePieActionObjs('patch', 'convert_to_static')
const renameListObj = makePieActionObjs('patch', 'list_name')

export const lockList = prependAppName(appName, lockListObj.pieDict)
export const unlockList = prependAppName(appName, unlockListObj.pieDict)
export const unAutoList = prependAppName(appName, unAutoListObj.pieDict)
export const renameList = prependAppName(appName, renameListObj.pieDict)

const loadList = 'LOAD_LIST'
const loadLists = 'LOAD_LISTS'

const actionTypes = prependAppName(
    appName,
    {
        loadList,
        loadLists,
        ...lockListObj.actionTypes,
        ...unlockListObj.actionTypes,
        ...unAutoListObj.actionTypes,
        ...renameListObj.actionTypes,
    }
)

export default actionTypes
